export function chunkArray(arr, chunkSize) {
  const chunks = [];
  for (let i = 0, len = arr.length; i < len; i += chunkSize) {
    chunks.push(arr.slice(i, i + chunkSize));
  }
  return chunks;
}

export const groupByProperty = (key, list) =>
  list.reduce((rv, i) => {
    // eslint-disable-next-line no-param-reassign
    rv[i[key]] = i;
    return rv;
  }, {});

export const groupListByProperty = (keyProp, list, comparator = undefined) => {
  const grouped = list.reduce((rv, i) => {
    const key = i[keyProp];
    // eslint-disable-next-line no-param-reassign
    (rv[key] = rv[key] || []).push(i);
    return rv;
  }, {});
  if (comparator) {
    Object.values(grouped).forEach((l) => l.sort(comparator));
  }
  return grouped;
};

// eslint-disable-next-line no-nested-ternary
const compare = (a, b) => (a === b ? 0 : a > b ? 1 : -1);

export const alphabetical = (key, list) => list.sort((a, b) => compare(a[key], b[key]));

export const mapValues = (obj, valueMapper) =>
  Object.entries(obj)
    .map(([key, val]) => [key, valueMapper(val)])
    .reduce((o, [k, v]) => {
      // eslint-disable-next-line no-param-reassign
      o[k] = v;
      return o;
    }, {});

export const unique = (ar, keyFn) => {
  if (!Array.isArray(ar)) return ar;

  const j = {};

  ar.forEach((v) => {
    if (keyFn) j[keyFn(v)] = v;
    else j[`${v}::${JSON.stringify(v)}`] = v;
  });

  return Object.keys(j).map((v) => j[v]);
};

export function arrayToMap(array, keyFn) {
  return new Map(array.map((element) => [keyFn(element), element]));
}

export function arraysEqual(a1, a2) {
  return !!a1 && !!a2 && !(a1 < a2 || a2 < a1);
}

// For a list of objects, determine min/max value for all observed keys
export function getMinMax(objArray, zeroMissing = false) {
  if (objArray.length === 0) return {};

  const minMax = Object.fromEntries(
    Object.entries(objArray.shift()).map(([key, value]) => [key, { min: value, max: value }])
  );

  objArray.forEach((obj) => {
    const observedKeys = [];
    Object.entries(obj).forEach(([key, value]) => {
      observedKeys.push(key);
      if (!minMax[key]) {
        minMax[key] = { min: zeroMissing ? 0 : value, max: value };
      } else {
        minMax[key].min = Math.min(minMax[key].min, value);
        minMax[key].max = Math.max(minMax[key].max, value);
      }
    });
    if (zeroMissing) {
      Object.keys(minMax)
        .filter((key) => minMax[key].min > 0 && !observedKeys.includes(key))
        .forEach((key) => {
          minMax[key].min = 0;
        });
    }
  });

  return minMax;
}
